__turbopack_context__.v({
  "className": "geist_mono_73ed58e6-module__6Mu7xq__className",
  "variable": "geist_mono_73ed58e6-module__6Mu7xq__variable",
});
